import { Action } from 'redux';

export const QUERY_FAMILY_USER_ROLES = 'QUERY_FAMILY_USER_ROLES';
export const ADD_FAMILY_USER_ROLE = 'ADD_FAMILY_USER_ROLE';
export const UPDATE_FAMILY_USER_ROLE = 'UPDATE_FAMILY_USER_ROLE';
export const DELETE_FAMILY_USER_ROLE = 'DELETE_FAMILY_USER_ROLE';

export interface FamilyUserRole {
  _id?: string;
  createdAt: Date;
  updatedAt: Date;
  name: string;
  value: string;
  // false = hidden at registration, admin-only
  selfSelectable?: boolean;
  // empty = any email domain; subdomains match
  allowedEmailDomains?: string[];
}

export interface QueryFamilyUserRoles extends Action {
  type: typeof QUERY_FAMILY_USER_ROLES;
  payload: FamilyUserRole[];
}

export interface DeleteFamilyUserRole extends Action {
  type: typeof DELETE_FAMILY_USER_ROLE;
  payload: string;
}

export interface AddFamilyUserRole extends Action {
  type: typeof ADD_FAMILY_USER_ROLE;
  payload: FamilyUserRole;
}

export interface UpdateFamilyUserRole extends Action {
  type: typeof UPDATE_FAMILY_USER_ROLE;
  payload: { roleId: string; updated: FamilyUserRole };
}

export interface FamilyUserRolesState {
  familyUserRoles: FamilyUserRole[];
}

export const INITIAL_STATE: FamilyUserRolesState = {
  familyUserRoles: [],
};
